import { PermissionsManager } from './permission-manager.ts';

export const appPermissions = new PermissionsManager();
